import React from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { createSite } from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

const SiteSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, i18n.t("site.form_name_invalid_error"))
    .required(i18n.t("site.form_name_required_error"))
});

export default () => {
  const dispatch = useDispatch();
  const asset = useSelector(state => state.asset);
  const handleSubmit = (name, longitude, latitude, notes) =>
    dispatch(createSite(name, longitude, latitude, notes));
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"sites"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link className="header-button" to={`/sites`}>
                  {t("common.back")}
                </Link>
                <h2>{t("site.create_title")}</h2>
              </div>
              <Formik
                initialValues={{
                  name: "",
                  longitude: "",
                  latitude: "",
                  notes: ""
                }}
                validationSchema={SiteSchema}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(
                    payload.name,
                    payload.longitude,
                    payload.latitude,
                    payload.notes
                  );
                  setSubmitting(false);
                }}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className={`form-item form-item-first`}>
                      <label htmlFor="name">{t("site.label_name")}</label>
                      <Field
                        name="name"
                        type="text"
                        placeholder="Rome Airport, Rome, Italy"
                      />
                      <ErrorMessage
                        name="name"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="latitude">{t("common.latitude")}</label>
                      <Field
                        name="latitude"
                        type="text"
                        placeholder="10.001122"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="longitude">{t("common.longitude")}</label>
                      <Field
                        name="longitude"
                        type="text"
                        placeholder="10.001122"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="notes">{t("site.label_notes")}</label>
                      <Field name="notes" component="textarea" placeholder="" />
                    </div>
                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("site.create_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
};
